/**
 * Bench Type constants
 * Maps to BenchTypeEnum in the backend Prisma schema
 */
export const BENCH_TYPES = {
  BENCH: 'BENCH',
  CHANGE: 'CHANGE',
};

/**
 * Get human-readable label for a bench type
 * @param {string} benchType - The bench type enum value
 * @returns {string} Human-readable label
 */
export const getBenchTypeLabel = (benchType) => {
  const labels = {
    [BENCH_TYPES.BENCH]: 'Bench',
    [BENCH_TYPES.CHANGE]: 'Change',
  };
  return labels[benchType] || benchType;
};

/**
 * Get color for bench type badge
 * @param {string} benchType - The bench type enum value
 * @returns {string} Hex color code
 */
export const getBenchTypeColor = (benchType) => {
  const colors = {
    [BENCH_TYPES.BENCH]: '#757575',  // Grey — default, not shown as badge
    [BENCH_TYPES.CHANGE]: '#E65100', // Deep orange — employee-requested change
  };
  return colors[benchType] || '#757575';
};

/**
 * Salary period constants
 * Maps to SalaryPeriodEnum in the backend Prisma schema
 */
export const SALARY_PERIODS = {
  HOUR: 'HOUR',
  MONTH: 'MONTH',
};

/**
 * Get human-readable label for salary period
 * @param {string} period - The salary period enum value
 * @returns {string} Human-readable label
 */
export const getSalaryPeriodLabel = (period) => {
  const labels = {
    [SALARY_PERIODS.HOUR]: '/hour',
    [SALARY_PERIODS.MONTH]: '/month',
  };
  return labels[period] || '';
};

/**
 * Salary amount type constants
 * Maps to SalaryAmountTypeEnum in the backend Prisma schema
 */
export const SALARY_AMOUNT_TYPES = {
  NET: 'NET',
  GROSS: 'GROSS',
};

/**
 * Get human-readable label for salary amount type
 * @param {string} type - The salary amount type enum value
 * @returns {string} Human-readable label
 */
export const getSalaryAmountTypeLabel = (type) => {
  const labels = {
    [SALARY_AMOUNT_TYPES.NET]: 'Net',
    [SALARY_AMOUNT_TYPES.GROSS]: 'Gross',
  };
  return labels[type] || '';
};

/**
 * Get color for bench days indicator
 * @param {number} days - Days on bench (negative means joining)
 * @returns {string} Hex color code
 */
export const getBenchDaysColor = (days) => {
  if (days < 0) { return '#6366F1'; }
  if (days > 90) { return '#DC2626'; }
  if (days > 30) { return '#F59E0B'; }
  return '#10B981';
};
